import { render, staticRenderFns } from "./InspectRejectDetailQuery.vue?vue&type=template&id=4581a6c4&scoped=true"
import script from "./InspectRejectDetailQuery.vue?vue&type=script&lang=js"
export * from "./InspectRejectDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./InspectRejectDetailQuery.vue?vue&type=style&index=0&id=4581a6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581a6c4",
  null
  
)

export default component.exports